/*@ngInject*/
const HiddenFieldDetailsModalController = function ($rootScope, $scope, options, coreConstant, localization, formatUtil) {

    $scope.viewModel = {
        formHiddenFieldList: options.formHiddenFieldList
    };

    $scope.getFieldClassName = function (formField) {
        return `formField-${formatUtil.formatAsSelector(formField.name)}`;
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umFormViewer')
    .controller('hiddenFieldDetailsModalController', HiddenFieldDetailsModalController);
